import { ERegionCode } from '@sureapp/platform-sdk';

export const regionCodes: ERegionCode[] = [
  'AZ',
  'CA',
  'CO',
  'GA',
  'IL',
  'IN',
  'MO',
  'OH',
  'OR',
  'PA',
  'SC',
  'TN',
  'TX',
  'VA',
  'WI',
];

export default {
  regionCodes,
};
